module.exports = __webpack_public_path__ + "img/partner6.2c92edb9.png";